function parseEventData(raw) {
  if (!raw) return null;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch (_error) {
      return null;
    }
  }
  return raw;
}

const state = {
  appContext: null,
};

function parseSessionInfoCookie() {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    if (!cookie.startsWith('cw_d_session_info=')) continue;
    try {
      return JSON.parse(decodeURIComponent(cookie.substring('cw_d_session_info='.length)));
    } catch (_error) {
      return null;
    }
  }
  return null;
}

export function bootstrapChatwootContext() {
  if (window.__KBW_CHATWOOT_CONTEXT__) return;

  window.__KBW_CHATWOOT_CONTEXT__ = true;
  window.addEventListener('message', event => {
    const payload = parseEventData(event.data);
    if (payload?.event === 'appContext' && payload.data) {
      state.appContext = payload.data;
    }
  });
}

export function requestAppContext() {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage('chatwoot-dashboard-app:fetch-info', '*');
  }
}

export function getCurrentAccountId() {
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get('account_id');
  if (fromQuery) return fromQuery;

  const fromConversation = state.appContext?.conversation?.account_id;
  if (fromConversation) return String(fromConversation);

  const fromEnv = window._env_?.REACT_APP_CHATWOOT_ACCOUNT_ID;
  if (fromEnv) return String(fromEnv);

  return '1';
}

export function getChatwootBaseUrl() {
  return window.location.origin;
}

export function getChatwootHeaders() {
  const session = parseSessionInfoCookie();
  const headers = {
    'Content-Type': 'application/json',
  };

  if (session?.['access-token']) {
    headers['access-token'] = session['access-token'];
  }

  if (session?.client) {
    headers.client = session.client;
  }

  if (session?.uid) {
    headers.uid = session.uid;
  }

  return headers;
}
